

export default {
  name: "NotAllowed",
  created() {
  },
};
